<template>
  <div class="article">
    <ith-top-bar />

    <ith-banner :item="banner" />

    <ith-grid-articles-detail />

    <ith-footer />
  </div>
</template>

<script>
export default {
  name: "ArticleDetail",

  data: () => ({
    banner: {
      title: "",
      text: "",
      image: "./../../img/banners/REVIEWS_NEWS_IMAGE.png"
    }
  })
};
</script>

<style scoped>
.article {
  background-color: #284367;
}
</style>
